export default __webpack_public_path__ + "static/media/banner.e20e26d9.gif";